import Navbar from "../components/Navbar";
import { FaAngleDoubleDown } from "react-icons/fa";
import SubscribeNowBanner from "../components/SubscribeNowBanner";
import SeasonSection from "../layouts/SeasonLayout";
import { Helmet } from 'react-helmet-async';

// Seasons.js
const SeasonTwo = () => {
    const scrollToContent = () => {
        const section = document.getElementById("session-tabs");
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };
    return (
        <>
            <Helmet>
                <title>Season Two - Art India Education</title>
            </Helmet>
            <main>
                <Navbar />
                {/* Top Half-Screen Banner Section */}
                <section className="relative h-screen w-full overflow-hidden font-['EB_Garamond','Nunito','sans-serif']">
                    <div className="relative w-full h-full overflow-hidden">
                        {/* 🔳 Overlay */}
                        <div className="absolute inset-0 bg-black/50 z-10"></div>

                        {/* 🖼️ Image */}
                        <img
                            src="Season-2-ep-banner.jpg"
                            alt={`banner`}
                            className="absolute top-[-25%] h-[150%] w-full object-cover z-0"
                        />

                        {/* 📄 Text Wrapper */}
                        <div className="absolute inset-0 z-20 flex flex-col justify-center items-center text-white text-center px-4">
                            <h1 className="text-8xl font-extrabold mb-6">Season Two</h1>
                            <p className="text-2xl font-medium max-w-2xl font-['EB_Garamond','Nunito','sans-serif']">
                                Explore the multifaceted world of contemporary Indian art, from its history and politics
                                to diverse narratives and emerging artists, in this captivating series presented by Art India Education.
                            </p>
                        </div>
                    </div>
                    {/* ⬇️ Double Down Arrow */}
                
                    <button
                        onClick={scrollToContent}
                        className="absolute bottom-6 left-1/2 transform -translate-x-1/2 z-30 text-white animate-bounce"
                        aria-label="Scroll to content"
                    >
                        <FaAngleDoubleDown size={32} />
                    </button>
                </section>
                <section id="session-tabs">
                    <SeasonSection
                        seasonTitle="SEASON TWO"
                        description={{
                            title: "Discovering and Delving into Indian Contemporary Art",
                            subtitle: "Discover contemporary Indian art's diverse narratives, forms & styles, established & emerging artists, and its social, political & historical contexts – presented by leading experts in the space.",
                        }}
                        seasonName="season-two-episodes"
                        episodes={[
                            {
                                title: "Episode One Trailer",
                                subtitle: "Newness and Nowness: Introducing Contemporary Art",
                                details: "Have you ever wondered what contemporary Indian art is all about? Join eminent art writer and independent curator, Meera Menezes in this masterclass as she introduces you to the diverse and dynamic world of contemporary art – decoding installation, performance and digital art in the season premiere.",
                                videoUrl: "https://player.vimeo.com/video/811220210?title=0&byline=0&portrait=0&autoplay=1&app_id=122963",
                            },
                            {
                                title: "Episode Two Trailer",
                                subtitle: "Who is Afraid of Installation Art?",
                                details: "Sandhya Bordewekar charts the evolution of installation art – from the masters to the contemporary. Explore path-breaking seminal works of installation art, its socio-political and historical background, and its diverse forms and disciplines in this engaging episode.",
                                videoUrl: "https://player.vimeo.com/video/811312036?title=0&byline=0&portrait=0&autoplay=1&app_id=122963",
                            },
                            {
                                title: "Episode Three Trailer",
                                subtitle: "Gendering Art",
                                details: "What role does gender play in shaping perspectives of the contemporary art world? Join Kamayani Sharma as she examines diverse concepts and themes through the lens of gender by spotlighting critically acclaimed works of India’s leading female artists.",
                                videoUrl: "https://player.vimeo.com/video/811967016?title=0&byline=0&portrait=0&autoplay=1&app_id=122963",
                            },
                            {
                                title: "Episode Four Trailer",
                                subtitle: "The Intersection of Art and Science: A Conversation between Jitish Kallat and Tasneem Zakaria Mehta",
                                details: "In the season finale, two celebrated stalwarts come together to examine the convergence of art and science. Art historian, curator and Honorary Director of Dr. Bhau Daji Lad Museum, Mumbai, Tasneem Zakaria Mehta gives us a glimpse into the creative process of one of India’s leading contemporary artists, Jitish Kallat – foregrounding his prominent works, artistic journey, influences and inspirations.",
                                videoUrl: "https://player.vimeo.com/video/812028271?title=0&byline=0&portrait=0&autoplay=1&app_id=122963",
                            },

                        ]}
                    />
                </section>

                <SubscribeNowBanner />
            </main>
        </>
    );
};
export default SeasonTwo;